export const environmentDefaults = {
  // Pioneer Server Endpoints
  baseUrl: 'http://localhost:8080',
  hostname: 'localhost',

  // angular-cli compile mode
  production: true,

  // AWS Configuration
  region: 'us-east-1',
  awsUri: 'amazonaws.com',

  // Log handlers and log levels
  logServices: {
    consoleLogSubscriber: {
      logLevel: 3
    },
    httpLogSubscriber: {
      logLevel: 0
    }
  },

  // Close messages at 3.5 seconds
  alertMessageTimer: 3500,

  events: {
    maxEvents: 50,
    acceptedFileExtensions: '.jpg, .jpeg, .pdf',
    acceptedFileTypes: [ 'application/pdf', 'image/jpeg' ],
    maxFileSize: 100
  },

  bulkEvents: {
    acceptedFileExtensions: '.csv',
    acceptedFileTypes: [ 'text/csv', 'text/x-csv', 'text/plain', 'application/vnd.ms-excel' ]
  },

  rsvps: {
    acceptedFileExtensions: '.csv',
    acceptedFileTypes: [ 'text/csv', 'text/x-csv', 'text/plain', 'application/vnd.ms-excel' ]
  },

  payments: {
    paymentDelayDaysAfterEventEnd: 3
  },

  googleAnalytics: {
    id: 'UA-92766055-1',
    loadType: 'auto'
  }

};



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment-defaults.ts